import React, { Component } from 'react';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import 'font-awesome/css/font-awesome.css';
import BrushSlider from './BrushSlider';
import DiscreteFilterList from './DiscreteFilterList';
import { toggleField } from '../../actions/filter.js'; 
import { fetchFilters } from '../../actions'
//import { setBusyText } from '../../actions';


/* * * * * * * * * * * * FilterBar * * * * * * * * * * * * * */
class FilterBarComp extends Component {

  componentWillMount(){
    this.setState({"timeout":null})
    if(this.props.filters.size === 0) {
      this.props.dispatch(fetchFilters());
    }
  }

  fieldClicked(id, e){
    this.props.dispatch(toggleField(id));
  }

  render(){
    var filterBar = [];
    var filters;

    if(this.props.filterFields.size){
      this.props.filterFields.forEach( (field,field_index) => {
        var fieldComponent = null;

        filters = this.props.filters.filter( (filter) => {
          return filter.get('field') === field.get('column') && filter.get('filter');
        });

        switch(field.get('type')){
            case 'discrete':
              if(filters.size > 1 && field.get('visible')){
                fieldComponent = (
                  <DiscreteFilterList
                    filters={filters}
                    field={field}
                    dispatch={this.props.dispatch}
                />)
              } else if(filters.size > 1 && !field.get('visible')) {
                fieldComponent = (<div></div>);
              } else {
                fieldComponent = null;
              }
            break

            case 'interval':
              if(filters.size > 0 && field.get('visible')){
                fieldComponent = (
                  <BrushSlider
                    filters={filters}
                    field={field}
                    dispatch={this.props.dispatch}
                  />)
              } else if(filters.size > 0 && !field.get('visible')) {
                fieldComponent = (<div></div>);
              } else {
                fieldComponent = null;
              }
            break

            default:
        }

        if(fieldComponent){
          filterBar.push(
          <div className="filterContainer" key={field.get('id')}>
            <h4 onClick={this.fieldClicked.bind(this, field.get('id'))}>
              {field.get('activeFilters') && <span><FontAwesome name={'check'} className='icon-left' /></span>}
              {field.get('title')}
              <span style={{marginLeft: '10px'}}>
                <FontAwesome name={field.get('visible') ? 'caret-down' : 'caret-right'} className='icon-right'/>
              </span>
            </h4>
              {fieldComponent}
          </div>
          )
       }
      })
    }

    return (
      <div className="filterBar" style={{maxHeight:this.props.template.compHeight, width: this.props.width, marginLeft: this.props.margin}}>
        {filterBar}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    filters : state.FilterApp.get('filters'),
    filterFields : state.FilterApp.get('filterFields'),
    isBusy: state.isBusy,
    template: state.Template
  }
}

const FilterBar = connect(mapStateToProps)(FilterBarComp)

export default FilterBar;



// WEBPACK FOOTER //
// ./src/components/FilterBar/index.js